import { render, staticRenderFns } from "./GeneratePhraseDialog.vue?vue&type=template&id=3bb5c8e8&scoped=true"
import script from "./GeneratePhraseDialog.vue?vue&type=script&lang=js"
export * from "./GeneratePhraseDialog.vue?vue&type=script&lang=js"
import style0 from "./GeneratePhraseDialog.vue?vue&type=style&index=0&id=3bb5c8e8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5c8e8",
  null
  
)

export default component.exports